import * as Sentry from "@sentry/react";

const isDev = import.meta.env.DEV;

Sentry.init({
  dsn: (import.meta.env.VITE_SENTRY_DSN as string) || "",
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  sendDefaultPii: false,
  environment: import.meta.env.VITE_APP_ENV as string,
  enabled: !isDev,
});

export default Sentry;
